import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { InvoiceModel } from "./invoice.model";
import { InvoiceService } from "./invoice.service";
import { QRCodeModel } from "../../qr/qrcode.model";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { CoreService } from "../../../core/header/core.service";
import { ShowQRModel } from "./showqr.model";
import * as FileSaver from 'file-saver';
import { ContactInvoicesComponent } from '../../contact/contact/contact-invoices.component';
import { MatDialog } from '@angular/material/dialog';
import { InvoiceDialogPaidedComponent } from './invoice-dialog-paided.component';
import { UserCompanyModel } from '../../user/usercompany/usercompany.model';
import { UserCompanyService } from '../../user/usercompany/usercompany.service';
import { InvoiceDialogSepaComponent } from './invoice-dialog-sepa.component';
import { InvoiceDialogFacturaEComponent } from './invoice-dialog-facturae.component';
import { InvoiceDialogRectificationComponent } from './invoice-dialog-rectification.component';
import { CoreComponent } from '../../../core/header/core.component';
import { InvoiceConst } from '../const';
import { DummyComponent } from '../../../shared/dummy.component';
import { consts } from '../../../consts';
import { ActualSelected, Utils } from '../../../shared/utils';
import { AccountingMovementsService } from '../../accounting/movements/accounting-movements.service';
import { TableService } from '../../../shared/components/table/table.service';
import { InvoiceDialogVerifactuComponent } from './invoice-dialog-verifactu.component';
import { InvoiceDialogProjectComponent } from './invoice-dialog-project.component';
import { ActivityService } from '../../user/activity/activity.service';
import { DeliveryNoteDialogPublishSelectedComponent } from '../deliverynotes/deliverynote-dialog-publish-selected.component';

@Component({
    selector: 'convfact-invoice-list-issued',
    templateUrl: './invoice-list-issued.component.html',
    styleUrls: ['./invoice.component.css'],
    standalone: false
})

export class InvoiceListIssuedComponent implements OnInit {

  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  constructor(
    private router: Router,
    private invoiceService: InvoiceService,
    private coreService: CoreService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
    public userCompanyService: UserCompanyService,
    private core: CoreComponent,
    public dummy: DummyComponent,
    private accountingMovementsService: AccountingMovementsService,
    private tableService: TableService,
    private activityService: ActivityService
  ) { }

  userCompany: UserCompanyModel;
  dataSource: InvoiceModel[] = [];
  showQRList: ShowQRModel[] = [];
  invoice: InvoiceModel;
  pdfFile: Blob = new Blob;
  empty: boolean = false;
  ready: boolean = false;
  select: boolean = false;
  year: number;
  month: number;
  currentActivityUid: string = this.core.activitySelected;
  sii: boolean;
  useContanet: boolean;
  qrCodeString: string;
  showQrCodeString: boolean = false;

  headerTable: any[] = InvoiceConst.headerTable;
  isProjectEnable: boolean = false;

  //Interacciones con la tabla------------------------------------------------------

  onInvoiceNumberClick(invoiceNumber) {
    this.invoice = invoiceNumber;
    this.pdf(this.invoice.uid, this.invoice.invoiceNumber, this.invoice.receiverName, false, false); // Llamar a la función pdf con el uid de la preinvoice
  }


  onAmountNumberClick(invoiceNumber) {
    this.invoicePaided(invoiceNumber.uid); // Llamar a la función cobros
  }

  //-------------------------------------------------------------------------------

  public rectification(uid: string): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    const selectedInvoice: InvoiceModel = this.dataSource.find(x => x.uid === uid);

    if (selectedInvoice != null) {

      if (selectedInvoice.totalPaided != 0) {
        this.displayInfo("No es posible rectificar una Factura que tiene cobros");
        return;
      }

    }

    const invoiceRectification = this.dialog.open(InvoiceDialogRectificationComponent, {
      data: { uid: uid, invoice: this.invoice }
    })
    invoiceRectification.afterClosed().subscribe(result => {
      this.dataSource = [];
      this.dummy.redirectTo(this.router.url);
    })
  }

  public sendSii(uid: string, invoiceNumber: string) {
    this.invoiceService.sendSii(uid).then(response => {
      FileSaver.saveAs(response, invoiceNumber + ".xml");
    })
  }

  public project(uid: string): void {
    const selectedInvoice = this.dataSource.find(i => i.uid === uid);
    if (!selectedInvoice) return;

    const dialogRef = this.dialog.open(InvoiceDialogProjectComponent, {
      width: '500px',
      data: { uid, invoice: selectedInvoice },
    });

    dialogRef.afterClosed().subscribe((facturaActualizada) => {
      if (facturaActualizada) {

        const index = this.dataSource.findIndex(f => f.uid === facturaActualizada.uid);

        if (index !== -1) {
          this.dataSource[index] = facturaActualizada;
        } else {

          this.getList();
        }

        this.displayInfo('Proyecto actualizado correctamente');
      }
    });
  }

  public invoicePaided(uid: string): void {
    const invoice = this.dataSource.find(x => x.uid == uid);

    const contactUid = invoice ? invoice.receiverUid : consts.EMPTY_GUID;

    const invoicePaidedref = this.dialog.open(InvoiceDialogPaidedComponent, {
      width: '860px',
      maxWidth: '96vw',
      maxHeight: '90vh',
      data: { uid: uid, isInvoice: true, isTicket: false, isIncome: true, contactUidCompensation: contactUid },
    });

    invoicePaidedref.afterClosed().subscribe(result => {
      this.dummy.redirectTo(this.router.url);
    })
  }

  public invoicePaidedSelected(selectedUids: string[]): void {
    // Eliminamos los que ya estan pagados y los que estan rectificados
    const dataSelected = this.dataSource.filter(row => selectedUids.includes(row.uid) && row.paided == null && row.rectifying == false);
    selectedUids = dataSelected.map(row => row.uid);


    // Obtenemos el monto restante a pagar de los elementos válidos seleccionados
    let amountSelectedUnpaid: number = 0;
    for (let i = 0; i < dataSelected.length; i++) {
      amountSelectedUnpaid += Utils.GetValueWithDecimals((dataSelected[i].total - dataSelected[i].totalPaided));
    }

    if (selectedUids.length > 0) {
      const invoicePaidedMultipleref = this.dialog.open(InvoiceDialogPaidedComponent, {
        width: '860px',
        maxWidth: '96vw',
        maxHeight: '90vh',
        data: { selectedUids: selectedUids, isInvoice: true, isTicket: false, isIncome: true, isMultiple: true, amountSelectedUnpaid: amountSelectedUnpaid },
      });

      invoicePaidedMultipleref.afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url);
      })
    } else {
      this.displayInfo('No tienes ninguna factura válida seleccionada');
    }
  }

  public openContactInvoices(uid: string): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    const client = true;
    const provider = false;
    const contactUid = this.dataSource.find(f => f.uid == uid).receiverUid;

    this.dialog.open(ContactInvoicesComponent, {
      width: '50%',
      data: { uid: contactUid, isClient: client, isProvider: provider }
    });
  }

  public pdfMail(uid: string): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.invoiceService.pdfMail(uid).then(response => {
      this.displayInfo(response);
      this.dummy.redirectTo(this.router.url);
    }).catch(error => {
      this.displayInfo(error.error['message']);
    })
  }

  public pdfMailMultipleAttach(selectedInvoices: string[]): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    if (selectedInvoices && selectedInvoices.length === 0) {
      this.displayInfo("Por favor, selecciona múltiples facturas");
      return;
    }

    if (selectedInvoices && selectedInvoices.length > 6) {
      this.displayInfo("El número máximo de facturas que se pueden enviar es 6");
      return;
    }

    const invoices = this.dataSource.filter(f => selectedInvoices.includes(f.uid));

    const receiverUid = invoices[0].receiverUid;

    const allInvoicesHaveSameReceiver = invoices.every(x => x.receiverUid === receiverUid);

    if (allInvoicesHaveSameReceiver === false) {
      this.displayInfo("Las facturas seleccionadas deben tener el mismo destinatario");
      return;
    }

    this.invoiceService.pdfMailMultipleAttach(selectedInvoices).then(response => {
      this.displayInfo(response);
      this.router.navigate[(this.router.url)];
    }).catch(err => {
      this.displayInfo(err['error']['message']);
    })
  }

  public listExport(uid: string) {
    for (const invoice of this.dataSource) {
      if (invoice.uid == uid) {
        if (!invoice.isSelected) {
          invoice.isSelected = true;
        } else {
          invoice.isSelected = false;
        }
      }
    }
  }

  public createPreinvoice() {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.router.navigate([this.router.url.replace("issued", "preinvoice") + '/create']);
  }

  public sepa(selectedInvoices, type): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    const invoiceSeparef = this.dialog.open(InvoiceDialogSepaComponent, {
      width: '650px',
      data: { invoicesCSV: selectedInvoices, type }
    });

    invoiceSeparef.afterClosed().subscribe(result => {
      this.dummy.redirectTo(this.router.url);
    })
  }

  public export(selectedInvoices): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.ready = false;
    this.invoiceService.export(selectedInvoices, consts.EMPTY_GUID).then(response => {
      FileSaver.saveAs(response, Utils.GetExcelName("Ingresos"));
      this.ready = true;
    })
  }

  public bookIssuedInvoices(selectedInvoices): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.ready = false;
    this.invoiceService.bookIssuedInvoices(selectedInvoices, consts.EMPTY_GUID).then(response => {
      FileSaver.saveAs(response, Utils.GetExcelName("Libro_Facturas_Emitidas"));
      this.ready = true;
    })
  }

  public excelContabilidad(selectedInvoices): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.ready = false;
    this.invoiceService.exportContabilidad(selectedInvoices, consts.EMPTY_GUID).then(response => {
      FileSaver.saveAs(response, Utils.GetExcelName("Contabilidad_Ingresos"));
      this.refreshExcelContabilidad(selectedInvoices);
      this.ready = true;
    })
  }

  public excelContabilidadGlobal(): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.ready = false;
    this.invoiceService.exportContabilidadGlobal(false, consts.EMPTY_GUID).then(response => {
      FileSaver.saveAs(response, Utils.GetExcelName("Contabilidad_Global_Ingresos"));
      this.refreshExcelContabilidad(false);
      this.ready = true;
    })
  }

  public refreshExcelContabilidad(selectedInvoices: any) {
    // false -> indica que es global, por lo que se marca todos
    if (selectedInvoices == false) {
      for (let i = 0; i < this.dataSource.length; i++) {
        if (!this.dataSource[i].rectifying) {
          this.dataSource[i].exportedToExcel = true;
        }
      }
    } else {
      for (let i = 0; i < this.dataSource.length; i++) {
        if (selectedInvoices.includes(this.dataSource[i].uid)) {
          this.dataSource[i].exportedToExcel = true;
        }
      }
    }
  }

  public displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    const self = this;
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  public showQr(uid: string) {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.invoiceService.getQrBase64(uid).then(res => {
      this.qrCodeString = 'data:image/png;base64,' + res.fileContents;
    }).catch(err => this.displayInfo('Ha ocurrido un error al generar el Qr'))
    this.showQrCodeString = true;
  }

  public onShowQr(show: boolean) {
    this.showQrCodeString = show;
  }

  public showQRCode(uid: string) {
    for (const invoice of this.showQRList) {
      if (invoice.uid == uid) {
        if (invoice.show == false) {
          invoice.show = true;
        } else {
          invoice.show = false;
        }
      }
    }
  }

  public paided(uid: string): void {
    this.invoiceService.loadData(uid).then(invoice => {
      this.invoice = invoice;
      this.invoice.paided = new Date();
      this.invoiceService.editData(uid, this.invoice);
    })
  }

  public pdf(uid: string, invoiceNumber: string, receiverName: string, isInvoice: boolean, isDeliveryNote: boolean): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    if (isInvoice && isDeliveryNote) {
      const fileName = invoiceNumber + "_" + receiverName + ".pdf";
      this.ready = false;
      this.invoiceService.pdf(uid, consts.EMPTY_GUID, 0).then(response => {
        FileSaver.saveAs(response, fileName);
        this.ready = true;
      });
    } else {
      const fileName = invoiceNumber + "_" + receiverName + ".pdf";
      this.ready = false;
      this.invoiceService.pdf(uid, consts.EMPTY_GUID).then(response => {
        FileSaver.saveAs(response, fileName);
        this.ready = true;
      });
    }
  }

  public ngOnInit() {
    this.dataSource = [];

    this.activityService.loadData(ActualSelected.activitySelected).then(activity => {
      this.isProjectEnable = activity.isProject;
    });

    this.currentActivityUid = this.core.activitySelected;

    this.showQRList = [];
    this.coreService.setName("Ingresos");
    this.getList();
  }

  public getList() {
    this.invoiceService.getListIssued(this.currentPage, this.itemsPerPage).then(
      data => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;



        for (const invoice of this.dataSource) {
          const temp = new ShowQRModel;
          temp.uid = invoice.uid;
          this.showQRList.push(temp);
          invoice.qrcode = new QRCodeModel;
          invoice.qrcode.uid = invoice.uid;
          invoice.qrcode.ver = 1;
          invoice.qrcode.type = 'invoice';
          invoice.qrstring = JSON.stringify(invoice.qrcode);
          invoice.isSelected = false;
        }
        if (this.dataSource.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }

        this.userCompanyService.loadData().then(response => {
          this.userCompany = response;
          this.sii = this.userCompany.sii;
          this.useContanet = this.userCompany.useContanet;
        })
        this.ready = true;
      }
    );
  }

  public pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  public excelCobros(selectedInvoices: string[]): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    // Eliminamos los que estan rectificados
    const dataSelected = this.dataSource.filter(row => selectedInvoices.includes(row.uid) && row.rectifying == false);
    selectedInvoices = dataSelected.map(row => row.uid);

    this.ready = false;
    this.invoiceService.exportExcelCobros(selectedInvoices).then(response => {
      FileSaver.saveAs(response, Utils.GetExcelName("Excel_Cobros"));
      this.ready = true;
    }).catch(err => {
      this.displayInfo('Ha ocurrido un error inesperado al exportar el documento excel');
      this.ready = true;
    })
  }

  public generateFacturae(uid: string, invoiceNumber: string) {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.dialog.open(InvoiceDialogFacturaEComponent, {
      data: { uid: uid, invoiceNumber: invoiceNumber },
      width: '500px',
      maxWidth: '96vw',
    });
  }

  showMessageVerifactu(uid: string) {
    this.dialog.open(InvoiceDialogVerifactuComponent, {
      data: { uid: uid, type: 'invoice' },
      width: '460px',
      maxWidth: '96vw',
    });
  }

  irpfCuenta() {
    this.router.navigate(['/invoice/irpf/1']);
  }

  statistics() {
    this.router.navigate(['/invoice/statistics']);
  }
  public trackByIndex(i: number) { return i; }

}
